import styled from "styled-components";

export const RegistrationButton = styled.button`
  font-weight: 800;
  height: 2.5rem;
  margin-left: 15px;
  width: 7rem;
`;

export const CalculateButton = styled.button`
  height: 3rem;
  width: 6rem;
  margin-top: 1rem;
  font-size: 18px;
  margin-right: 1.5rem;
`;

export const RequiredInputBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const QuickLinkButtonSize = styled.button`
  margin-top: 3%;
  margin-left: 2%;
  width: 100%;
`;

export const BusinessButton = styled.button`
  margin-top: 3%;
  margin-right: 2%;
  width: 100%;
`;

export const MQuickLinkButtonSize = styled.button`
  /* margin-top: 3%; */
  margin-left: -5%;
  width: 100%;
`;
export const MQuickLinkButtonSize2 = styled.button`
  /* margin-left: %; */
  width: 100%;
`;

export const MQuickLinkButtonSize3 = styled.button`
  /* margin-top: 3%; */
  margin-right: 0%;
  width: 100%;
`;

export const NewCalculateButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: ${(props) => (props.disabled ? "#ccc" : "#357fed")};
  color: white;
  font-weight: 800;
  font-size: 16px;
  border-radius: 8px;
  width: 100px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  transition: all 0.3s ease;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    background-color: ${(props) => (props.disabled ? "#ccc" : "#2663eb")};
  }
`;
